/**
 * What opening a PDF has to tell the user once the viewer is up (image markup spec 4.7): "Report pages kept: this
 * file was edited elsewhere", "N photos could not be recovered". openLocalPdf runs before the route change, so the
 * notices ride sessionStorage to the local viewer, which shows them once.
 */
const KEY = 'pmt.importNotices';

export function setImportNotices(notices: string[]): void {
    try {
        if (notices.length > 0) sessionStorage.setItem(KEY, JSON.stringify(notices));
        else sessionStorage.removeItem(KEY);
    } catch {
        // No storage: the import itself is unaffected.
    }
}

/** The pending notices, removed in the same read. */
export function takeImportNotices(): string[] {
    try {
        const raw = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        const v: unknown = raw ? JSON.parse(raw) : [];
        return Array.isArray(v) ? v.filter((s): s is string => typeof s === 'string') : [];
    } catch {
        return [];
    }
}
